import * as methods from './validators';

export default {
    methods,
};
